export const START_SEARCH_TYPING = "START_SEARCH_TYPING"
export const FOCUS = "FOCUS"
export const DEFOCUS = "DEFOCUS"
export const ADD_SEARCH_PROPERTIES = "ADD_SEARCH_PROPERTIES"
export const ADD_LISTING = "ADD_LISTING"
export const LISTINGS_LOADING = "LISTINGS_LOADING"
export const HAS_NO_MORE = "HAS_NO_MORE"
export const LISTING_SKIP = "LISTING_SKIP"
export const CLEAR_ON_UNMOUNT = "CLEAR_ON_UNMOUNT"